import React from 'react';

import {useLineWizard} from './LineWizardScreen';
import {StepClient} from './steps/StepClient';
import {StepLine} from './steps/StepLine';
import {StepAccounts} from './steps/StepAccounts';
import {StepCampaigns} from './steps/StepCampaigns';

/** El paso que corresponde a la ruta. El marco ya validó que `step` sea uno de los cuatro. */
export function LineWizardStep() {
    const {step} = useLineWizard();
    if (step === 'cliente') return <StepClient/>;
    if (step === 'linea') return <StepLine/>;
    if (step === 'cuentas') return <StepAccounts/>;
    return <StepCampaigns/>;
}
